import _ from 'lodash'
import update from 'immutability-helper'
import {
  FETCH_WSSID,
  FETCH_SE_WSSID,
  FETCH_USER,
  FETCH_SE_USER,
  FETCH_PRIVILEGE_PAGES,
  CHECK_PRIVILEGE,
  SET_CRUMB,
  SET_ERROR_BOX,
  SET_LOADING,
  SET_PAGE_INFO,
  SET_TOAST,
  SET_USER,
  SET_NAVIGATION_PAGES,
  SWITCH_ERROR_BOX,
  SWITCH_TOAST,
  SET_ALERTS,
  CREATE_ALERT,
  DISMISS_ALERT,
  DISMISS_LAST_ALERT,
  INVOKE_REDIRECT,
  SET_I13NDATA,
  SET_ERROR_BOUNDARY_ERROR,
  SET_PAGE_USER_TYPE_BY_COOKIE
} from '../actions/actionTypes'
import appConf from '../../../conf/appConf'

const initState = {
  clientInfo: {
    browser: '',
    os: '',
    isMobile: undefined
  },
  crumb: {},
  envConf: {
    appHost: '',
    scmHost: ''
  },
  env: '',
  isProd: true, // default true
  isSupplier: false,
  isSeller: false,
  externalSellerLoginUrl: undefined,
  errorBox: {
    active: false,
    content: '',
    title: ''
  },
  loading: {},
  privilege: {
  },
  navigationPages: [],
  privilegedPages: [],
  redirect: {
    shouldRedirect: false,
    url: '',
    timeout: 500
  },
  user: {
    id: undefined,
    isLogin: false,
    name: '',
    supplierId: '',
    supplierName: '',
    simulated: false,
    identity: {
      name: '',
      isSupplier: false,
      isPM: false
    },
    cookieType: '',
    profile: {
      shipTypes: [],
      accessoryContracts: []
    }
  },
  toast: {
    active: false,
    type: 'normal',
    iconType: 'ec-check',
    content: ''
  },
  alerts: [],
  wssid: '',
  i13nData: null,
  errorBoundaryError: null,
  debugError: null
}

const serviceErrorReducer = (state, action) => {
  // service fail

  switch (action.type) {
    case FETCH_WSSID:
    case FETCH_USER:
    default:
      return state
  }
}

const serviceReducer = (state, action) => {
  // service error
  if (action.payload && action.error) {
    return serviceErrorReducer(state, action)
  }

  // service success
  switch (action.type) {
    case FETCH_WSSID:
    case FETCH_SE_WSSID: {
      const wssid = action.payload.wssid
      return Object.assign({}, state, { wssid })
    }
    case FETCH_USER:
    case FETCH_SE_USER: {
      const { payload } = action
      const isValidPayload = _.isObject(payload)
      if (isValidPayload) {
        const { cookieType } = payload
        const localPayload = {
          ...payload,
          identity: {
            name: payload.fullName,
            isSeller: cookieType === appConf.seCookieKey,
            isSupplier: cookieType === appConf.spCookieKey,
            isPM: cookieType === appConf.secretDashboardCookieKey
          }
        }
        return update(state, { user: { $merge: localPayload } })
      }
      return state
    }
    case FETCH_PRIVILEGE_PAGES: {
      const { navigationPages, privilegedPages } = action.payload
      return { ...state, navigationPages, privilegedPages }
    }
    case CHECK_PRIVILEGE: {
      let authorized = false
      if (!action.error) {
        authorized = true
      }
      return update(state, { privilege: { $set: { authorized } } })
    }
    default:
      return state
  }
}

export const reducerName = 'page'
const pageReducer = (state = initState, action) => {
  let errorBox
  switch (action.type) {
    case FETCH_WSSID:
    case FETCH_SE_WSSID:
    case FETCH_USER:
    case FETCH_SE_USER:
    case FETCH_PRIVILEGE_PAGES:
    case CHECK_PRIVILEGE:
      return serviceReducer(state, action)

    case INVOKE_REDIRECT: {
      const url = action.payload.url
      const timeout = action.payload.timeout || 0
      return update(state, { redirect: { $set: { shouldRedirect: true, url, timeout } } })
    }

    case SET_CRUMB: {
      const crumb = Object.assign({}, state.crumb, action.payload.crumb)
      return Object.assign({}, state, { crumb })
    }

    case SET_PAGE_INFO: {
      const payload = action.payload
      const isProd = payload.pageInfo.env === 'production'
      return Object.assign({},
        state,
        { ...action.payload.pageInfo, isProd } // include envConf, clientInfo, env, route
      )
    }

    case SET_USER: {
      return Object.assign({},
        state,
        { user: action.payload.user }
      )
    }

    case SET_LOADING: {
      const loading = Object.assign({}, state.loading, action.payload.loading)
      return Object.assign({}, state, { loading })
    }

    case SET_ERROR_BOX: {
      errorBox = Object.assign({}, state.errorBox, action.payload.errorBox)
      return Object.assign({}, state, { errorBox })
    }

    case SWITCH_ERROR_BOX: {
      errorBox = Object.assign({}, state.errorBox, {
        active: action.payload.active
      })
      return Object.assign({}, state, { errorBox })
    }

    case SET_TOAST: {
      const toast = Object.assign({}, state.toast, action.payload.toast)
      return Object.assign({}, state, { toast })
    }
    case SWITCH_TOAST: {
      const toast = Object.assign({}, state.toast, {
        active: action.payload.active
      })
      return Object.assign({}, state, { toast })
    }

    case SET_ALERTS: {
      let tmpAlerts = action.payload.alerts || []
      tmpAlerts = tmpAlerts.map(alert => Object.assign({}, alert, { id: new Date().getTime() }))
      return update(state, { alerts: { $push: tmpAlerts } })
    }

    case CREATE_ALERT: {
      // change alert id from array length to timestamp to prevent exception 'duplicate component key'
      const nextAlerts = update(state.alerts, {
        $push: [{
          id: new Date().getTime(),
          type: action.payload.type,
          message: action.payload.message,
          description: action.payload.description
        }]
      })
      return update(state, { alerts: { $set: nextAlerts } })
    }

    case DISMISS_ALERT: {
      if (!action.payload.alertId) {
        return state
      }
      const filteredAlerts = state.alerts.filter((alert) => {
        return alert.id !== action.payload.alertId
      })
      return update(state, { alerts: { $set: filteredAlerts } })
    }

    case DISMISS_LAST_ALERT: {
      const localAlerts = [].concat(state.alerts)
      localAlerts.shift()
      return update(state, { alerts: { $set: localAlerts } })
    }

    case SET_NAVIGATION_PAGES:
      return update(state, { navigationPages: { $set: action.payload.navigationPages } })

    case SET_I13NDATA:
      return update(state, { i13nData: { $set: action.payload.i13nData } })

    case SET_ERROR_BOUNDARY_ERROR:
      return update(state, { errorBoundaryError: { $set: action.payload.errorBoundaryError }, debugError: { $set: action.payload.debugError } })

    case SET_PAGE_USER_TYPE_BY_COOKIE: {
      const { isSeller, isSupplier } = action.payload
      return update(state, { isSeller: { $set: isSeller }, isSupplier: { $set: isSupplier } })
    }

    default:
      return state
  }
}

export const reducerObject = { [reducerName]: pageReducer }
export default pageReducer
